var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurvedCaretSolid = function SvgCurvedCaretSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48 2a1.98 1.98 0 0 0-.594-1.406 1.98 1.98 0 0 0-2.812 0l-17.656 17.75c-1.557 1.567-4.09 1.556-5.657 0L3.406.594a1.98 1.98 0 0 0-2.812 0 1.98 1.98 0 0 0 0 2.812l17.875 17.781c3.134 3.114 8.198 3.103 11.312-.031l17.625-17.75c.39-.392.596-.894.594-1.406"
  })));
};
export default SvgCurvedCaretSolid;